<div class="auth-form-card">
  <div class="auth-form-header">
    <img
      src="/assets/logos/cyflare-one-logo-new-colors.png"
      alt="Cyflare One"
      class="auth-form-logo"
    />
    <h2>Reset Password</h2>
  </div>

  <form [formGroup]="resetPasswordForm">
    <div class="auth-form-field">
      <kendo-floatinglabel text="Your Email Address">
        <input
          kendoTextBox
          class="form-control"
          formControlName="email"
          (input)="onEmailInput($event)"
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-field">
      <kendo-floatinglabel text="Confirmation Code">
        <input
          kendoTextBox
          class="form-control"
          formControlName="confirmationCode"
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-field">
      <kendo-floatinglabel text="New Password">
        <kendo-textbox
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          class="form-control"
        >
          <ng-template kendoTextBoxSuffixTemplate>
            <button
              kendoButton
              fillMode="clear"
              type="button"
              (click)="togglePasswordVisibility()"
              [svgIcon]="showPassword ? eyeSlashIcon : eyeIcon"
            ></button>
          </ng-template>
        </kendo-textbox>
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-field">
      <kendo-floatinglabel text="Confirm Password">
        <kendo-textbox
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          class="form-control"
        >
          <ng-template kendoTextBoxSuffixTemplate>
            <button
              kendoButton
              fillMode="clear"
              type="button"
              (click)="toggleConfirmPasswordVisibility()"
              [svgIcon]="showConfirmPassword ? eyeSlashIcon : eyeIcon"
            ></button>
          </ng-template>
        </kendo-textbox>
      </kendo-floatinglabel>

      @if (resetPasswordForm.hasError('mismatch') && (resetPasswordForm.get('confirmPassword')?.touched || resetPasswordForm.get('confirmPassword')?.dirty)) {
        <p class="auth-form-error">Passwords do not match</p>
      }
    </div>

    <div class="auth-form-submit">
      <button
        [disabled]="resetPasswordForm.invalid"
        kendoButton
        class="cyflare-btn-primary cyflare-btn-lg cyflare-btn-block"
        type="button"
        (click)="resetPassword()"
      >
        Reset Password
      </button>
      <kendo-formhint class="auth-form-hint">
        Password Must Contain:<br />- Minimum of 10 characters<br />- At least one uppercase character<br />- At least one lowercase character<br />- At least one number<br />- At least one special character (no spaces allowed)
      </kendo-formhint>
    </div>

    <div class="auth-form-footer">
      <span>Having trouble signing in?</span>
      <a
        href="mailto:support@cyflare.com"
        kendoButton
        fillMode="clear"
      >
        Contact Us
      </a>
    </div>

    <div class="auth-form-secondary">
      <button
        kendoButton
        class="cyflare-btn-secondary cyflare-btn-lg cyflare-btn-block"
        type="button"
        (click)="back()"
      >
        Go Back
      </button>
    </div>
  </form>
</div>
